{
  "endTime": "Pabaigos laikas",
  "startTime": "Pradžios laikas",
  "time": "Laikas"
}
